import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import MainHeader from './components/MainHeader'

import { Link } from 'react-router-dom'
import { useHasAccess } from '../components/HasAccess'
import { Permission } from '../utils/permissions'
import { LayoutFooter } from './components/LayoutFooter'

const { Content } = Layout

export const MarketingLayout: React.FC = () => {
  const { hasAccess } = useHasAccess()

  const subItems = [
    {
      key: 'campaigns',
      label: <Link to={'campaigns'}>Campaigns</Link>,
      hasAccess: hasAccess(Permission.listPush),
    },
    {
      key: 'loyalty-tiers',
      label: <Link to={'loyalty-tiers'}>Loyalty tiers</Link>,
      hasAccess: hasAccess(Permission.listLoyaltyTier),
    },
    {
      key: 'referral',
      label: <Link to={'referral'}>Referral</Link>,
      hasAccess: hasAccess([Permission.listReferral]),
    },
    {
      key: 'featured-venue',
      label: <Link to={'featured-venue'}>Featured venue</Link>,
      hasAccess: hasAccess(Permission.listFeaturedVenue),
    },
    {
      key: 'communication',
      label: <Link to={'communication'}>Communication</Link>,
      hasAccess: hasAccess([Permission.updateVenue]),
    },
  ]

  return (
    <Layout>
      <MainHeader subItems={subItems.filter((item) => item.hasAccess)} />
      <Layout style={{ minHeight: '100vh', marginTop: 128 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
        <LayoutFooter />
      </Layout>
    </Layout>
  )
}
